/**
 * @desc 确认事件
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {
  /** id */
  id: number;
}

export function request(
  data: defs.EventsToDismiss,
  params: Params,
): Promise<defs.StandardReturn<void>> {
  return defHttp.post({
    url: '/wap/event/{id}/confirm',
    data,
    params,
  });
}

export function mock(
  data: defs.EventsToDismiss,
  params: Params,
): Promise<defs.StandardReturn<void>> {
  return defHttp.post({
    url: '/mock/wap/event/{id}/confirm',
    data,
    params,
  });
}
